import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// Service
import { BroadcastService } from '@cv-invision/core';
import { UCDPOverrideComponent } from '../../../../../shared/ucdp-override/ucdp-override.base';
import { OrderInboxService } from '../../../../../inbox/service/order-inbox.service';

@Component({
	selector: 'cv-ucdp-score-dialog',
	templateUrl: '../../../../../shared/ucdp-override/ucdp-override.base.html',
	styleUrls: ['../../../../../shared/ucdp-override/ucdp-override.base.scss']
})
export class UCDPScoreDialogComponent extends UCDPOverrideComponent {
	constructor(
		protected override inboxService: OrderInboxService,
		protected override broadcastService: BroadcastService,
		protected override dialogRef: DynamicDialogRef,
		protected override dialogConfig: DynamicDialogConfig
	) {
		super(inboxService, broadcastService, dialogRef, dialogConfig);
	}
}
